<template>
  <v-card
    v-if="!$auth.isAuthenticated && $auth.loading"
    class="fill-height d-flex justify-center align-center pa-4"
  >
    <j-loader />
  </v-card>
  <j-error-alert
    v-else-if="!$auth.isAuthenticated"
    :value="{ message: 'not authenticated' }"
    retry-text="Login"
    v-on:retry="login()"
  />
  <router-view v-else />
</template>

<script>
import JErrorAlert from '@/ui/controls/JErrorAlert'
import authMixin from '@/mixins/authMixin'

export default {
  components: {
    JErrorAlert
  },
  mixins: [ authMixin ]
}
</script>